@if (!disabled()) {
  <div class="extra-menu-bar">
    <ng-content />
  </div>
}

<div class="extra-router">
  <ion-router-outlet />
</div>
